import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CredentialFiltersValueStateType = {
  number?: string;
  licensePlate?: string;
  holderName?: string;
  holderDocument?: string;
  street?: string;
  district?: string;
  routeId?: string;
  expirationDate?: string;
  status?: '' | 1 | 2;
};

const initialState: CredentialFiltersValueStateType = {
  number: '',
  licensePlate: '',
  holderName: '',
  holderDocument: '',
  street: '',
  district: '',
  routeId: '',
  expirationDate: '',
  status: 1,
};

export const credentialsFiltersValuesSlice = createSlice({
  name: 'credentialsFiltersValues',
  initialState,
  reducers: {
    setCredentialsFiltersValues: (
      state,
      action: PayloadAction<CredentialFiltersValueStateType>,
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetCredentialsFiltersValues: () => {
      return initialState;
    },
  },
});

export const { setCredentialsFiltersValues, resetCredentialsFiltersValues } =
  credentialsFiltersValuesSlice.actions;
